/**
 * GroupFlowTab — campaign-group "Flow" sub-tab.
 *
 * Thin wrapper that reuses {@link CampaignFlowsTab} so the same Flow Optimizer
 * UI used on `/campaigns/:id` is available inside the SMSWiser campaign-group
 * stats panel. The group's `trafficProvider` picks the tracker. Tres Commas
 * follows the registry's `flowOptimizer` capability: the same UI once it has
 * it, a "not available yet" card (and no tracker request) until then.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { assertNever, trackerCan } from '@trafficpulse/shared';

import { TrackerPendingCard } from '@/features/trackers';
import type { StatsTrafficProvider } from '@/pages/admin/SmswiserCampaignDetailPage/types';

import { TrackerGroupFlowTab } from './TrackerGroupFlowTab';

export const FLOW_OPTIMIZER_PENDING = 'the Flow Optimizer is not available yet';

interface GroupFlowTabProps {
  trafficProvider: StatsTrafficProvider;
  trafficCampaignId: string | null;
}

export const GroupFlowTab: FC<GroupFlowTabProps> = ({
  trafficProvider,
  trafficCampaignId,
}) => {
  switch (trafficProvider) {
    case 'VOLUUM':
      return <TrackerGroupFlowTab provider="voluum" trafficCampaignId={trafficCampaignId} />;
    case 'BINOM':
      return <TrackerGroupFlowTab provider="binom" trafficCampaignId={trafficCampaignId} />;
    case 'TRES_COMMAS':
      return trackerCan('tres-commas', 'flowOptimizer') ? (
        <TrackerGroupFlowTab provider="tres-commas" trafficCampaignId={trafficCampaignId} />
      ) : (
        <TrackerPendingCard tracker="tres-commas" message={FLOW_OPTIMIZER_PENDING} />
      );
    default:
      return assertNever(trafficProvider, 'traffic provider');
  }
};

export default GroupFlowTab;
